export const userManagementError = {
  departmentError: "Department name already exists.",
  imagesizeError: "Please upload an image under 1 MB.",
  activeError: "Status updated.",
  deactivateError:
    "To deactivate this department lead, please remove or move all assigned employees first.",
  sendmailError:
    "Couldn't send the email. Please try again.",
  invalidCredentialsError: "Incorrect username or password. Please try again.",
  loginCredentialsError: "Incorrect username or password. Please try again.",
  emailReturnResponseError:
    "Your account is deactivated. Please contact your administrator.",
  memberDeletedError: "Please select at least one employee.",
  selectEmployeeError:
    "Session update failed. Please log in again.",
};

export const leaveManagementError = {
  leaveSummaryError: "Couldn't load leave summary. Please try again.",
  networkResponseError: "Something went wrong. Please try again.",
  deletedleaveError: "Leave deleted.",
  dataFetchError: "Couldn't load data. Please try again.",
  checkInError: "Check-in time must be earlier than check-out time.",
  breakError: "Break end time must be after break start time.",
  breakInError: "Please enter a break start time.",
  breakOutError: "Please enter a break end time.",
  editBreakError: "Break end time must be after break start time.",
};

export const projectError = {
  networkResponseError: "Something went wrong. Please try again.",
  enterTaskName: "Please enter a task name.",
  enterError: "Please enter your comments.",
  invalidStartTime: "Please enter a start time.",
  invalidEndTime: "Please enter an end time.",
  startTime: "Start time must be before end time.",
  endTime: "End time must be after start time.",
  taskMaterial: "Task materials removed.",
  fetchError: "Couldn't load data. Please try again.",
  labelName: "Label name is required.",
  taskNameError: "Please enter a task name.",
  sprintnameError:
    "Sprint name must be alphanumeric and under 32 characters.",
  projectnameError: "Please select a project.",
};

export const minimum10Digits = "Minimum 10 digits are required.";
export const minimum3Characters = "Minimum 3 characters, no spaces.";
